// Excel експортът на „Натовареност" — редовете както са на екрана
// (филтрирани и подредени); периодът е етикетът от екрана, минутите са числа.

import type { TFunction } from "i18next";

import { exportToExcel, type ExcelColumn } from "../../../../utils/excelExport";
import type { OccupancyPeriodRow } from "./occupancyMath";

type Options = {
  rows: readonly OccupancyPeriodRow[];
  t: TFunction;
};

export const exportOccupancy = ({ rows, t }: Options) => {
  const columns: ExcelColumn<OccupancyPeriodRow>[] = [
    {
      header: t("reportsPage.salesPeriodsPeriodColumn"),
      value: (row) => (row.sublabel ? `${row.label} · ${row.sublabel}` : row.label),
      width: 24,
    },
    { header: t("reportsPage.rvKpiReservations"), value: (row) => row.reservations, width: 12 },
    { header: t("reportsPage.rvKpiGuests"), value: (row) => row.guests, width: 10 },
    { header: t("reportsPage.rvStatus_upcoming"), value: (row) => row.upcoming, width: 12 },
    { header: t("reportsPage.rvStatus_seated"), value: (row) => row.seated, width: 12 },
    { header: t("reportsPage.rvStatus_completed"), value: (row) => row.completed, width: 12 },
    { header: t("reportsPage.rvStatus_cancelled"), value: (row) => row.cancelled, width: 12 },
    { header: t("reportsPage.rvStatus_expired"), value: (row) => row.expired, width: 12 },
    { header: t("reportsPage.rvExportAvgDurationMinutes"), value: (row) => row.avgPlannedMinutes, width: 16 },
    { header: t("reportsPage.rvExportAvgStayMinutes"), value: (row) => row.avgSeatedMinutes, width: 16 },
  ];

  exportToExcel<OccupancyPeriodRow>({
    filename: t("reportsPage.rvOccupancy"),
    sheetName: t("reportsPage.rvOccupancy"),
    columns,
    rows: [...rows],
  });
};
